import { StripeActionTypes, StripeState } from './stripe.types';

const initialState = {
  billingCustomerId: null
} as StripeState;

// eslint-disable-next-line @typescript-eslint/default-param-last
const stripeReducer = (state = initialState, action: StripeActionTypes): typeof initialState => {
  switch (action.type) {
    case 'SET_BILLING_CUSTOMER':
      return {
        ...state,
        billingCustomerId: action.payload
      };
    default:
      return state;
  }
};

export default stripeReducer;
